import { useEffect, useState } from "react"
import { useAppSelector } from '../app/hooks';

const useIsPFC = () => {
  const {user} = useAppSelector(state => state.auth);
  const [isPFC, setIsPFC] = useState(false);
  useEffect(() => {
    setIsPFC(user?.role.toLowerCase() === "pfc" || user?.PENS_SCOPE?.toLowerCase() === 'pfc');
  }, [user]);
  return isPFC;
}

export default useIsPFC;
